import { UploadErrorEvent } from "devextreme/ui/file_uploader";
import { getFileTooLargeMessage } from "../../base/upload-limits";

const defaultUploadError = "无法上传文件，请稍后再试，如仍无法上传，请与管理员联系！";

function isGenericUploadFailedMessage(msg: string) {
    return /upload\s*failed|上传失败/i.test(msg);
}

function normalizeResponseText(raw?: string): string {
    if (!raw) {
        return "";
    }

    let text = raw.trim();
    if (!text || text.startsWith("<")) {
        return "";
    }

    if (text.startsWith('"') && text.endsWith('"')) {
        try {
            return String(JSON.parse(text));
        } catch {
            return text.slice(1, -1);
        }
    }

    if (text.startsWith("{")) {
        try {
            const obj = JSON.parse(text);
            return String(obj.message || obj.title || obj.detail || "").trim();
        } catch {
            return "";
        }
    }

    return text.length < 500 ? text : "";
}

/**
 * 从 FileUploader 失败事件中提取服务端返回的明确错误（如 400 正文）。
 */
export function getUploadErrorMessage(e: UploadErrorEvent, fallback: string = defaultUploadError): string {
    const request = e.request as XMLHttpRequest | undefined;
    const status = request?.status ?? 0;
    const text = normalizeResponseText(request?.responseText);

    if (status === 413) {
        return getFileTooLargeMessage();
    }

    if (status >= 400 && status < 500 && text) {
        return text;
    }

    if (typeof e.error === "string" && e.error.trim() && !isGenericUploadFailedMessage(e.error)) {
        return e.error.trim();
    }

    if (status === 0) {
        // 连接被中断时常见于超大文件被网关/服务器拒绝
        return getFileTooLargeMessage();
    }

    return fallback;
}

export {
    DEFAULT_MAX_UPLOAD_BYTES,
    getFileTooLargeMessage,
    getMaxUploadBytes,
    isFileTooLarge,
    setMaxUploadBytes
} from "../../base/upload-limits";
